module.exports = __webpack_public_path__ + "img/check.3ac6019b.svg";